export default {
  authentication: {
    components: {
      forgottenPassword: {
        "default": {
          copy: 'Introduce tu dirección de correo electrónico registrada y te ayudaremos a restablecer tu contraseña'
        },
        backButtonText: 'Volver'
      },
      login: {
        emailAccount: {
          backButtonText: 'Volver'
        },
        newPasswordRequired: {
          passwordPolicy: {
            copy: '_TODO: We\'ve updated our password policy to improve account security. Your account is still safe but a new password is required.'
          },
          instructionsLineOne: '_TODO: You\'ll receive an email to set a new password.',
          instructionsLineTwo: 'Asegúrate de revisar todas las carpetas en tu bandeja de entrada, incluyendo la de correo no deseado.',
          resendEmailCopy: '¿No recibiste el email? ',
          resendEmailButtonText: 'Haz click para reenviar'
        }
      },
      registration: {
        contactPreferences: {
          skipButtonText: 'Omitir este paso'
        },
        createAccount: {
          backButtonText: 'Volver'
        }
      }
    },
    hooks: {
      useAccountLogin: {
        error: {
          submissionError: {
            message: 'Su email y/o contraseña son incorrectos. Por favor, pruebe otravez o seleccione Olvidé contraseña'
          }
        }
      },
      useAuthPageProps: {
        landing: {
          heading: 'Crear una cuenta.',
          title: 'Crear una cuenta.'
        },
        loginLanding: {
          heading: 'Iniciar sesión.',
          title: 'Iniciar sesión.'
        },
        loginForm: {
          heading: 'Iniciar sesión.',
          title: 'Iniciar sesión.'
        },
        loginVerifyAccount: {
          heading: '_TODO: Your account is not yet verified.',
          title: '_TODO: Verification required'
        },
        createAccount: {
          heading: 'Crear una cuenta.',
          title: 'Crear una cuenta'
        },
        resetPassword: {
          heading: '¿Has olvidado tu contraseña?',
          title: '¿Has olvidado tu contraseña?'
        },
        changeEmailConfirmation: {
          heading: '_TODO: Enter your password.',
          title: '_TODO: Enter your password'
        },
        contactPreferences: {
          heading: 'Mantente en contacto.',
          title: 'Mantente en contacto'
        },
        forgottenPassword: {
          "default": {
            heading: '¿Has olvidado tu contraseña?',
            title: '¿Has olvidado tu contraseña?'
          }
        },
        emailSentConfirmation: {
          verifyAccount: {
            heading: 'Vamos a verificar tu cuenta.',
            title: 'Verifica tu cuenta'
          },
          resetPassword: {
            heading: 'Comprueba tu bandeja de entrada.',
            title: 'Comprueba tu bandeja de entrada'
          }
        },
        newPasswordRequired: {
          "default": {
            heading: 'Comprueba tu bandeja de entrada.',
            title: 'Comprueba tu bandeja de entrada'
          }
        },
        success: {
          "default": {
            heading: '¡Ya está todo listo!',
            title: '¡Ya está todo listo!'
          },
          accountAlreadyVerified: {
            heading: 'Ya hemos verificado tu cuenta.',
            title: 'Ya hemos verificado tu cuenta'
          },
          changeEmail: {
            heading: '_TODO: You\'re all set up and ready to go!',
            title: '_TODO: You\'re all set up and ready to go!'
          },
          loginAccountVerified: {
            heading: '_TODO: Your account is now verified.',
            title: '_TODO: Your account is now verified'
          },
          resetPassword: {
            heading: 'Tu contraseña ha sido cambiada',
            title: 'Tu contraseña ha sido cambiada'
          }
        },
        error: {
          "default": {
            heading: 'Crear cuenta.',
            title: 'Algo no ha salido bien'
          },
          errorWithRetrySignUp: {
            heading: 'Algo no ha salido bien.',
            title: 'Algo no ha salido bien'
          },
          errorWithResendEmail: {
            heading: 'Lo sentimos, algo ha ido mal.',
            title: 'Lo sentimos, algo ha ido mal'
          },
          linkExpiredWithResendEmail: {
            heading: 'Link de verificación caducado.',
            title: 'Link de verificación caducado'
          },
          loginGeneralError: {
            heading: 'Iniciar sesión.',
            title: 'Algo no ha salido bien'
          },
          loginVerificationErrorWithRetry: {
            heading: 'Algo no ha salido bien.',
            title: 'Algo no ha salido bien'
          },
          loginVerificationErrorWithResendEmail: {
            heading: 'Lo sentimos, algo ha ido mal.',
            title: 'Lo sentimos, algo ha ido mal'
          },
          loginVerificationLinkExpiredWithResendEmail: {
            heading: 'Link de verificación caducado.',
            title: 'Link de verificación caducado'
          },
          passwordResetTokenExpired: {
            heading: 'Link de contraseña caducado.',
            title: 'Link de contraseña caducado'
          },
          changeEmailVerifyLinkGeneralError: {
            heading: '_TODO: Sorry, something went wrong.',
            title: '_TODO: Sorry, something went wrong'
          },
          changeEmailVerifyLinkInvalid: {
            heading: '_TODO: Your email address hasn\'t changed.',
            title: '_TODO: Your email address hasn\'t changed'
          }
        }
      },
      useAuthStatusProps: {
        success: {
          changeEmail: {
            buttonText: '_TODO: Take me back to where I started',
            heading: '_TODO: Success!',
            subheading: '_TODO: You\'re all set! Let\'s get you back on your journey.'
          },
          login: {
            accountVerified: {
              buttonText: 'Iniciar sesión',
              heading: '¡Éxito!'
            }
          },
          registration: {
            buttonText: 'Llévame de vuelta al inicio',
            buttonTextLogin: 'Pulsa aquí para iniciar sesión',
            heading: '¡Éxito!',
            subheading: 'Iniciado sesión como:'
          },
          resetPassword: {
            buttonText: 'Iniciar sesión con tu cuenta',
            loggedInButtonText: 'Aceptar',
            contentPartOne: 'Puedes actualizar tu contraseña en cualquier momento',
            contentPartTwo: 'Ajustes'
          }
        },
        error: {
          changeEmailVerifyLinkGeneralError: {
            buttonText: '_TODO: Go to My Account',
            content: '_TODO: Any changes you made may not be saved, please go back to My Account and try again.'
          },
          changeEmailVerifyLinkInvalid: {
            buttonText: '_TODO: Resend email',
            content: '_TODO: Sorry, that didn\'t work. Please click below to send a new link.'
          },
          registration: {
            buttonText: 'Inténtalo otra vez',
            heading: 'Algo no ha salido bien.',
            subheading: 'Prueba otra vez a crear una cuenta.'
          },
          resetPassword: {
            withRetry: {
              buttonText: 'Reintentar',
              content: 'Haz clic aquí para volver a intentarlo.'
            },
            withResendEmail: {
              buttonText: 'Reenviar email',
              content: '¡Lo sentimos! Intenta hacer clic a continuación para enviar un nuevo email de verificación'
            },
            tokenExpired: {
              buttonText: 'Reenviar email',
              content: 'El link que te enviamos ya no es válido, lo hacemos para mantener segura tu cuenta. Haz clic a continuación para enviar un nuevo email de restablecimiento de contraseña olvidada.'
            }
          },
          login: {
            generalLoginError: {
              heading: '_TODO: Something didn\'t go quite right',
              subheading: '_TODO: Please try logging in again later',
              buttonText: '_TODO: Try again'
            },
            verificationErrorWithResendEmail: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: Sorry about that! Try clicking below to send a new verification email.'
            },
            verificationErrorWithRetry: {
              buttonText: '_TODO: Retry',
              content: '_TODO: We\'ve encountered an issue while attempting to verify your account. Please try logging in again and we\'ll send you a new verification email. Alternatively, contact support at the address below.'
            },
            verificationLinkExpiredWithResendEmail: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: The link we sent you is no longer valid, we do this to keep your account secure. Click below to send a new verification email.'
            },
            verificationRequired: {
              buttonText: '_TODO: Resend verification email',
              content: '_TODO: We recently sent you a link to verify your account. This is to keep your account secure. This link may have expired, please click below to send a new link.'
            }
          }
        }
      },
      useChangeEmailConfirmation: {
        error: {
          submissionError: {
            incorrectPassword: '_TODO: Your password is incorrect'
          }
        }
      },
      useStepperProps: {
        steps: {
          first: 'Crear una cuenta',
          second: 'Preferencias',
          third: 'Completar'
        }
      }
    },
    toastNotifications: {
      success: {
        genericEmailReSent: '_TODO: Email has been re-sent.',
        verificationEmailReSent: '_TODO: Verification email has been re-sent.'
      },
      error: {
        genericErrorMessage: '_TODO: Something went wrong. Please try again.',
        verificationEmailFailed: '_TODO: Failed to send verification email.'
      }
    }
  },
  myHub: {
    collection: {
      calloutText: 'Guarda contenido y crea colecciones con una cuenta gratuita',
      errorMessage: 'No se han podido cargar los siguientes resultados. Por favor prueba más tarde.',
      loadNext: 'Cargar siguientes',
      taglineItem_one: 'elemento',
      taglineItem_few: 'elementos',
      taglineItem_many: 'elementos',
      taglineItem_other: 'elementos',
      taglineItem: 'elemento',
      taglineItem_plural: 'elementos',
      taglineItem_0: 'elemento',
      taglineItem_1: 'elementos',
      taglineItem_2: 'elementos'
    },
    collections: {
      taglineSaved: 'guardado',
      createButtonText: 'Crear una nueva colección',
      loadErrorMessage: 'No hemos podido cargar los siguientes artículos. Por favor, inténtalo más tarde.',
      loadNext: 'Cargar siguientes',
      tagline_one: 'Colección',
      tagline_few: 'Colecciones',
      tagline_many: 'Colecciones',
      tagline_other: 'Colecciones',
      tagline: 'Colección',
      tagline_plural: 'Colecciones',
      tagline_0: 'Colección',
      tagline_1: 'Colecciones',
      tagline_2: 'Colecciones'
    },
    components: {
      accountSettings: {
        banner: {
          changeEmailCheckInbox: {
            text1: '_TODO: We have sent an email to {{email}}',
            text2: '_TODO: Please click the link in your email to change your email address.'
          },
          error: {
            text1: '_TODO: Oops something went wrong! Any changes you made may not be saved.',
            text2: '_TODO: Please try again later or contact us if the problem persists {{supportEmail}}'
          }
        },
        myDetails: {
          layoutTitle: '_TODO: Account Settings',
          layoutSubtitle: '_TODO: My Details',
          basicInfoSection: {
            title: '_TODO: Basic info',
            editButtonLabel: '_TODO: Click here to edit'
          }
        }
      },
      savedItem: {
        card: {
          ariaLabel: {
            save: 'Guardar',
            unsave: 'Eliminar'
          }
        }
      },
      searchFilter: {
        ariaLabel: {
          searchButton: 'Buscar'
        },
        filteredResultsHeading: 'Mostrando resultados para: ',
        sr: {
          filteredItemsResults_one: 'resultado',
          filteredItemsResults_few: 'resultados',
          filteredItemsResults_many: 'resultados',
          filteredItemsResults_other: 'resultados',
          filteredItemsResults: 'resultado',
          filteredItemsResults_plural: 'resultados',
          filteredItemsResults_0: 'resultado',
          filteredItemsResults_1: 'resultados',
          filteredItemsResults_2: 'resultados'
        }
      }
    },
    hooks: {
      useResponseCodes: {
        firstName: {
          tooLong: '_TODO: First name must be no longer than 100 characters'
        },
        lastName: {
          tooLong: '_TODO: Last name must be no longer than 100 characters'
        },
        screenName: {
          notUnique: '_TODO: This screen name has already been taken',
          tooLong: '_TODO: Screen name must be no longer than 100 characters'
        },
        email: {
          invalid: '_TODO: Please enter a valid email address',
          notUnique: '_TODO: This email address has already been taken',
          tooLong: '_TODO: Email address must be no longer than 100 characters'
        }
      }
    },
    overview: {
      createButtonText: 'Crear una colección nueva',
      defaultTitle: 'Mi Zona',
      ugcButtonLabel: 'Ver más',
      ugcCreateButtonText: 'Añadir receta'
    },
    ownItems: {
      createButtonText: 'Añadir receta nueva',
      loadErrorMessage: 'No se han podido cargar los siguientes resultados. Por favor prueba más tarde.',
      loadNext: 'Cargar siguientes',
      tabData: {
        all: 'Todos',
        published: 'Publicado',
        unpublished: 'Descartado'
      },
      tabFilterError: 'Ha habido un problema al filtrar tus recetas. Aquí tienes todas las recetas.'
    },
    savedItems: {
      collectionTaglineItem_one: 'artículo',
      collectionTaglineItem_few: 'artículos',
      collectionTaglineItem_many: 'artículos',
      collectionTaglineItem_other: 'artículos',
      collectionTaglineItem: 'artículo',
      collectionTaglineItem_plural: 'artículos',
      collectionTaglineItem_0: 'artículo',
      collectionTaglineItem_1: 'artículos',
      collectionTaglineItem_2: 'artículos',
      collectionTaglineSaved: 'guardado',
      loadErrorMessage: 'No hemos podido cargar los siguientes artículos. Por favor, inténtalo más tarde.',
      loadNext: 'Cargar siguientes'
    }
  },
  nextCore: {
    signIn: {
      errorLineOne: '¿Buscas algo en particular?',
      errorLineTwo: 'Prueba',
      errorLineThree: 'Iniciando sesión',
      errorLineFour: 'Para ver esta página.',
      errorLineFive: '¿Aún no tienes una cuenta gratuita?',
      errorLineSix: 'Únete aquí'
    }
  },
  postCreator: {
    confirmation: {
      metaTitle: 'Crea una receta - Gracias',
      newRecipeButtonText: 'Nueva Receta',
      ownRecipeButtonText: 'Mis Recetas'
    },
    create: {
      metaTitle: 'Crear una Receta'
    },
    edit: {
      editFormTitle: 'Editar Receta',
      metaTitle: 'Editar Receta'
    },
    recipeDetails: {
      dropDownOptions: {
        hours: 'horas',
        mins: 'minutos'
      },
      heading: 'Detalles de la Receta',
      label: {
        cookTime: 'Tiempo de cocción (aprox.)',
        difficulty: 'Nivel de Dificultad',
        extraTime: 'Tiempo Extra (Opcional)',
        image: 'Imagen',
        prepTime: 'Tiempo de preparación (aprox.)',
        servings: 'Raciones',
        shortIntro: 'Intro breve (10-15 palabras)',
        title: 'Título de la Receta (Corto y descriptivo)'
      },
      placeholder: {
        extraTime: 'e.g. más reposo',
        makes: 'e.g. 8 piezas',
        serves: 'e.g. 4',
        shortIntro: 'Cuéntanos sobre tu receta',
        title: 'e.g. Tarta de manzana de la abuela'
      },
      servingsButton: {
        makes: 'Unidades',
        serves: 'Raciones'
      },
      skillLevel: {
        dropDownOptions: {
          challenge: 'Un desafío',
          defaultText: '(Por favor, selecciona uno)',
          easy: 'Fácil',
          moreEffort: 'Más difícil'
        }
      }
    },
    recipeForm: {
      defaultFeedback: {
        error: 'Ups... Lo sentimos, algo ha ido mal',
        info: 'Por favor guarda la imagen antes de mandarla'
      },
      links: {
        back: 'Volver a mis recetas',
        preview: 'Previsualizar',
        saveDraft: 'Guardar boceto'
      }
    },
    recipeIngredients: {
      heading: 'Ingredientes',
      information: {
        lineOne: 'Por favor usa una medida si es posible (tenemos una útil',
        lineTwo: 'guía de conversión',
        lineThree: 'para ayudar)',
        lineFour: 'Puedes dividir tus ingredientes en grupos e.g. salsas, rellenos etc.'
      },
      ingredient: {
        buttonText: 'Añadir siguiente ingrediente',
        label: 'Ingrediente',
        placeholder: '500g de contramuslos de pollo, en dados'
      },
      ingredientGroup: {
        buttonText: 'Añadir título de sección',
        heading: 'Título',
        placeholder: 'Para la salsa'
      }
    },
    recipeMethodSteps: {
      heading: 'Método',
      method: {
        buttonText: 'Añadir siguiente paso',
        label: 'Paso',
        placeholder: 'Primero, hierve el arroz'
      }
    },
    statusFeedback: {
      createLinkeText: 'crear una receta nueva',
      info: {
        approved: 'Tu receta ha sido aprobada',
        "default": 'Ups, algo ha ido mal',
        draft: 'Tus recetas no han sido enviadas aún',
        pending: 'Tu receta está esperando approbación',
        rejected: 'Tu receta no ha sido aprobada'
      },
      submissionChoice: {
        approved: 'Ver tu receta',
        "default": 'Volver a tu zona',
        draft: 'continuar editando tu receta',
        heading: 'Puede que te apetezca'
      },
      submittedText: 'Tu receta ha sido enviada para ser aprobada y ya no puede ser editada'
    },
    submit: {
      formValidation: {
        defaultMessage: 'Por favor, confirma que has leído nuestros términos y condiciones'
      },
      informationLineOne: 'Por favor, sólo subas tus propias recetas.',
      informationLineTwo: 'Por motivos de copyright no publicaremos ninguna receta subida',
      informationLineThree: 'Por favor, sólo subas tus propias recetas. Por motivos de copyright, no podemos publicar recetas subidas por nuestros usuarios si originalmente fueron escritas por cualquier otra fuente. Puedes leer nuestros términos y condiciones antes de subir tu receta.',
      informationLineFour: 'términos y condiciones',
      informationLineFive: 'para más información antes de enviar tu receta.',
      metaTitle: 'Crear una Receta - Términos y Condiciones',
      previewButtonText: 'Previsualizar',
      publishButtonText: 'Publicar',
      termsLabel: 'Haz click para confirmar que has leído nuestros términos y condiciones.'
    }
  }
};